@if (isOpen()) {
  <div class="ph-8 flex-row space-between">
    <strong>Log üzenetek</strong>
    <ion-button (click)="developerService.clearLogs()" color="danger" fill="outline">
      <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
    </ion-button>
  </div>
  <div class="panel" @verticalCollapse>
      <ion-list>
        @for (log of logs(); track log) {
          <ion-item>
            {{ log }}
          </ion-item>
        }
      </ion-list>
  </div>
}
